import React from 'react';
import { Form } from 'antd';

import InputWithSearchModal from '../../components/InputWithSearchModal'

import UserFilter from '../UserFilter'
import UserSelector from '../UserSelector'


export default function AddAdminSchool(props) {
    const { auth, form } = props;
    React.useEffect(()=>{
        form.resetFields();
    }, [])
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    // shkolaID: object.ID
                }}
            >
                <Form.Item
                    name={"user"}
                    label={"Пользователь"}
                    rules={[{ required: true, message: 'Укажите пользователя!' }]}
                >
                    <InputWithSearchModal valueAsObject={true} auth={auth} title={"Поиск пользователя"} url={"/api/find/finduserfilter"} object={{ }}
                        searchForm={UserFilter}
                        selectForm={UserSelector} />
                </Form.Item>
            </Form>
        </>
    );
}
